import type React from 'react';
import layoutStyles from '../../../../styles/modules/layout.module.scss';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import { DELIVERY_STATUS } from '../../constants';
import type { DeliveryManagementDetail } from '../../types';
import { estimatedShippingDateText } from '../../utils';
import styles from './ShippingStatusCard.module.scss';

export interface ShippingStatusCardProps {
  deliveryDetail: DeliveryManagementDetail;
}

const ShippingStatusCard = ({ deliveryDetail }: ShippingStatusCardProps) => {
  // 配送ステータスの日本語変換
  const getStatusLabel = (status: string): string => {
    const statusEntry = Object.values(DELIVERY_STATUS).find((entry) => entry.value === status);
    return statusEntry?.text || status;
  };
  const fullAddress = () => {
    const address = deliveryDetail.delivery.address;
    const hyphenZip = `${address.zip.slice(0, 3)}-${address.zip.slice(3)}`;
    return (
      <>
        {`〒${hyphenZip}`}
        <br />
        {`${address.province}${address.city}${address.address1} ${address.address2 || ''}`}
      </>
    );
  };

  return (
    <>
      <div className={styles.deliveryInfoCard}>
        <div className={styles.eventNameContainer}>
          <h1 className={styles.eventName}>{deliveryDetail.event.name}</h1>
        </div>
        <div className={styles.infoItem}>
          <p className={styles.infoLabel}>出荷指示ID:</p>
          <p className={styles.infoValue}>{deliveryDetail.shippingInstructionId}</p>
        </div>
        <div className={styles.infoItem}>
          <p className={styles.infoValue}>
            {estimatedShippingDateText({
              estimatedShippingDate: deliveryDetail.delivery.estimatedShippingDate || undefined,
            })}
          </p>
        </div>
        <div className={styles.infoItem}>
          <p className={styles.infoLabel}>配送ステータス:</p>
          <p className={styles.infoValue}>{getStatusLabel(deliveryDetail.delivery.status)}</p>
        </div>
        <div className={styles.infoItem}>
          <p className={styles.infoLabel}>保有数:</p>
          <p className={styles.infoValue}>{deliveryDetail.delivery.acquiredCount}</p>
        </div>
      </div>
      <div className={`${utilsStyles.mtMedium}`}>
        <h1 className={layoutStyles.pageTitle}>配送先住所</h1>
      </div>
      <div className={`${styles.addressContainer} ${styles.deliveryInfoCard} ${utilsStyles.mtSmall}`}>
        <div>{fullAddress()}</div>
        <div>{deliveryDetail.delivery.address.fullName} 様</div>
      </div>
      {deliveryDetail.delivery.address.memoForUser && (
        <>
          <div className={`${utilsStyles.mtMedium}`}>
            <h1 className={layoutStyles.pageTitle}>備考</h1>
          </div>
          <div className={`${styles.addressContainer} ${styles.deliveryInfoCard} ${utilsStyles.mtSmall}`}>
            <div className={styles.memoForUser}>{deliveryDetail.delivery.address.memoForUser}</div>
          </div>
        </>
      )}
    </>
  );
};

export default ShippingStatusCard;
